<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Apps Selecionados </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${collapsed ? 'top' : 'bottom'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow>
                <CCol md="12">
                  <ul>
                    <li v-for="app in form.aplicativos" :key="app" style="list-style:none; font-size:16px;">
                      <CIcon name="cil-check" style="color:green;" />
                      {{ app }}
                    </li>
                  </ul>
                </CCol>
              </CRow>
              <CRow>
                <p> {{ isApps }} </p>
              </CRow>
              <div v-if="isMailChimp">
                <CRow>
                  <CCol sm="6">
                    <validation-provider
                      name="usuário MailChimp"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        label="Usuário MailChimp"
                        :invalid-feedback="errors[0]"
                        v-model="form.login"
                        placeholder="Informe seu usuário do MailChimp"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                  <CCol sm="6">
                    <validation-provider
                      name="senha MailChimp"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        label="Senha MailChimp"
                        :invalid-feedback="errors[0]"
                        v-model="form.senha"
                        placeholder="Informe sua senha do MailChimp"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                </CRow>
              </div>
              <div v-if="isGoogle">
                <CRow>
                  <CCol sm="6">
                    <validation-provider
                      name="login Google"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        label="Login Google"
                        v-model="form.login"
                        :invalid-feedback="errors[0]"
                        placeholder="E-mail conta Google"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                  <CCol sm="6">
                    <validation-provider
                      name="senha Google"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        v-model="form.senha"
                        label="Senha conta Google"
                        :invalid-feedback="errors[0]"
                        placeholder="Senha conta Google"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                </CRow>
              </div>
              <div v-if="isJustUno">
                <CRow>
                  <CCol sm="6">
                    <validation-provider
                      name="usuário JustUno"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        label="Usuário JustUno"
                        v-model="form.login"
                        :invalid-feedback="errors[0]"
                        placeholder="E-mail conta JustUno"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                  <CCol sm="6">
                    <validation-provider
                      name="senha JustUno"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        label="Senha"
                        valid-feedback
                        v-model="form.senha"
                        :invalid-feedback="errors[0]"
                        placeholder="Senha conta JustUno"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                </CRow>
              </div>
              <div v-if="isFacebook">
                <CRow>
                  <CCol sm="6">
                    <validation-provider
                      name="login Facebook"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        label="Login Facebook"
                        :invalid-feedback="errors[0]"
                        v-model="form.login"
                        placeholder="E-mail conta Facebook"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                  <CCol sm="6">
                    <validation-provider
                      name="senha Facebook"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        label="Senha Facebook"
                        v-model="form.senha"
                        :invalid-feedback="errors[0]"
                        placeholder="Senha conta Facebook"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                </CRow>
              </div>
              <div v-if="isInstagram">
                <CRow>
                  <CCol sm="6">
                    <validation-provider
                      name="login Instagram"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        label="Login Instagram"
                        :invalid-feedback="errors[0]"
                        v-model="form.login"
                        placeholder="E-mail conta Instagram"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                  <CCol sm="6">
                    <validation-provider
                      name="senha Instagram"
                      rules="required|max:50"
                      v-slot="{ errors, valid, touched }"
                    >
                      <CInput
                        valid-feedback
                        label="Senha Instagram"
                        :invalid-feedback="errors[0]"
                        v-model="form.senha"
                        placeholder="Senha conta Instagram"
                        :is-valid="touched == false ? null : valid ? true : false"
                      />
                    </validation-provider>
                  </CCol>
                </CRow>
              </div>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'appsForm',
    props: {
      show: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        isMailChimp: false,
        isJustUno: false,
        isGoogle: false,
        isFacebook: false,
        isInstagram: false,
        isApps: ''
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.apps
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.apps 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'apps')
        }
      }
    },
    mounted() {
      this.validateApp();
    },
    methods: {
      ...mapActions(['saveAplicativos', 'updateApplications']),
      save() {
        this.saveAplicativos(this.form);
      },
      update() {
        this.updateApplications(this.form)
      },
      validateApp() {
        for (const key of this.form.aplicativos) {
          if (key.name === 'E-mail Marketing (MailChimp)') {
            this.isMailChimp = true;
          }
          if (key.name === 'Loja do Facebook e Instagram') {
            this.isFacebook = true;
            this.isInstagram = true
          }
          if (key.name === 'Google Shopping') {
            this.isGoogle = true;
          }
          if (key.name === 'Formulários de Captação de E-mail e Alertas (JustUno)') {
            this.isJustUno = true;
          }
        }
        if (form.aplicativos.length == 0) {
          this.isApps = 'Nenhum app selecionado'
        }
      }
    }
  }
</script>
